import {IssueTypePicker, type IssueType, DefaultIssueTypeAnchor} from '@github-ui/item-picker/IssueTypePicker'
import {useIssueCreateDataContext} from './contexts/IssueCreateDataContext'
import {Suspense, useCallback} from 'react'
import {useIssueCreateConfigContext} from './contexts/IssueCreateConfigContext'
import {FormControl} from '@primer/react'
import {LABELS} from './constants/labels'

type IssueTypeSelectorProps = {
  repo: string
  owner: string
}

export const IssueTypeSelector = ({repo, owner}: IssueTypeSelectorProps) => {
  const {issueType, setIssueType} = useIssueCreateDataContext()

  const {optionConfig} = useIssueCreateConfigContext()
  const sharedConfigProps = {
    insidePortal: optionConfig.insidePortal,
    shortcutEnabled: optionConfig.singleKeyShortcutsEnabled,
  }

  const setIssueTypeCallback = useCallback(
    (issueTypes: IssueType[] | null) => {
      setIssueType(issueTypes?.[0] || null)
    },
    [setIssueType],
  )

  return (
    <Suspense>
      <FormControl>
        <FormControl.Label as="span" id={LABELS.selectIssueTypeLabel}>
          {LABELS.typePickerLabel}
        </FormControl.Label>

        <IssueTypePicker
          repo={repo}
          owner={owner}
          readonly={false}
          activeIssueType={issueType}
          onSelectionChange={setIssueTypeCallback}
          anchorElement={anchorProps => (
            <DefaultIssueTypeAnchor
              readonly={false}
              activeIssueType={issueType}
              anchorProps={anchorProps}
              {...sharedConfigProps}
            />
          )}
          ariaLabelledBy={LABELS.selectIssueTypeLabel}
          {...sharedConfigProps}
        />
      </FormControl>
    </Suspense>
  )
}

try{ IssueTypeSelector.displayName ||= 'IssueTypeSelector' } catch {}